<template>
  <div v-if="disabled">
    <el-button
      type="primary"
      round
      :disabled="false"
      class="translation-button"
    >
      翻訳する
    </el-button>
  </div>

  <div v-else>
    <el-popover
      placement="top"
      trigger="hover"
      content="利用できるAIモデルがありません"
    >

    <template #reference>
      <el-button
        type="primary"
        round
        :disabled="false"
        class="translation-button__disable"
      >
        翻訳する
      </el-button>
    </template>
    </el-popover>
  </div>
</template>

<script>
import { ElButton, ElPopover } from 'element-plus';

export default {
  name: 'Title',
  props: {
    disabled: {
      type: String,
      required: true,
      default: '',
    },
  },

  components: { 
    ElButton,
    ElPopover,
  },
};
</script>

<style lang="scss" scoped>
.translation-button{
  font-size: 24px;
  padding: 1.5rem 2rem;
  border-radius: 30px;
  background-color: rgb(118, 63, 208);
  border-color: rgb(118, 63, 208);
}
.translation-button:hover,
.translation-button:focus
.translation-button:active {
  background-color: rgb(72, 37, 121);
  border-color: rgb(72, 37, 121);
}
.translation-button__disable {
  font-size: 24px;
  padding: 1.5rem 2rem;
  border-radius: 30px;
  background-color: #ccc;
  border-color: #ccc;
}
.translation-button__disable:hover {
  cursor: default;
}
</style>